import { render, staticRenderFns } from "./pageBanner.vue?vue&type=template&id=6792700c&scoped=true&"
import script from "./pageBanner.vue?vue&type=script&lang=js&"
export * from "./pageBanner.vue?vue&type=script&lang=js&"
import style0 from "./pageBanner.vue?vue&type=style&index=0&id=6792700c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6792700c",
  null
  
)

export default component.exports